import React from "react";
import { useNavigate } from "react-router-dom";
//import styles
import style from "./a.module.scss";
//import components
import Navbar from "../../components/Navbar/Navbar";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import HeroSection from "./components/HeroSection";
import Card from "./components/Card";
//import assets
import searchIcon from "../../assets/icons/search.svg"
import settingIcon from "../../assets/icons/setting.svg"
import profileImage from "../../assets/test-profile-image.svg";


const testCardData = [
	{
		name:"Sarthak Pawar",
		about:"Full stack developer",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/sarthak",
		imgSrc: profileImage
	},
	{
		name:"Sarthak Pawar",
		about:"Full stack developer",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/sarthak",
		imgSrc: profileImage
	},
	{
		name:"Sarthak Pawar",
		about:"Full stack developer",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/sarthak",
		imgSrc: profileImage
	},
	{
		name:"Sarthak Pawar",
		about:"Full stack developer",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/sarthak",
		imgSrc: profileImage
	},
	{
		name:"Sarthak Pawar",
		about:"Full stack developer",
		skills:["React","HTML","CSS","Java","Pythons","C++","JavaScript","Unreal"],
		profileId:"/sarthak",
		imgSrc: profileImage
	},

]

const Mentor = () => {

	const SearchPanel = () => {
		return(
			<div className={style.searchPanel}>
				<div className={style.inputDiv}>
					<img src={searchIcon} alt="icon"></img>
					<input placeholder="Search any skill"></input>
				</div>
				<div className={style.inputDiv}>
					<img src={settingIcon} alt="icon"></img>
					<select>
						<option value="Skills">Skills</option>
						<option value="Name">Name</option>
					</select>
				</div>
				<div>
					<PrimaryButton  title="Search"/>
				</div>
			</div>
		)
	}

	const SearchResults = () => {
		return (
			<div className={style.searchResults}>
				{testCardData.map((data) =>{
					return(
						<Card data={data}/>
					)
				})}
			</div>
		)
	}

	return (
		<div>
		<Navbar />
		<div className="AppNavbarGap"></div>
		<HeroSection />
		<SearchPanel />
		<SearchResults />
		</div>
	);
};

export default Mentor;
